import React from "react";
import { useHistory } from "react-router";
import { Button, Table } from "antd";
import { useModel } from "../../../models";
import { useEffect } from "react";
import { goPage } from "../../layout/pageDefinition";
import moment from "moment";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '序号',
        width: 50,
        render: (_, __, index) => <span>{index + 1}</span>,
    },

    {
        title: '盘库单号',
        width: 120,
        dataIndex: 'inventoryListCode',
    },
    /*{
        title: '组织机构',
        width: 200,
        dataIndex: 'orgName',
        align: 'left',
    },*/
    {
        title: '仓库',
        width: 120,
        dataIndex: 'warehouseName',
    },
    {
        title: '起始时间',
        width: 120,
        dataIndex: 'startTime',
        render: text => text ? moment(text).format("YYYY-MM-DD HH:mm:SS") : ""
    },
    {
        title: '结束时间',
        width: 120,
        dataIndex: 'endTime',
        render: text => text ? moment(text).format("YYYY-MM-DD HH:mm:SS") : ""
    },

    {
        title: '制单人',
        width: 100,
        dataIndex: 'createUser',
    },
    {
        title: '制单时间',
        width: 120,
        dataIndex: 'createTime',
    },
    {
        title: '状态',
        width: 80,
        dataIndex: 'orderStatusName',
    },
    {
        title: '备注',
        width: 200,
        dataIndex: 'inventoryListDesc',
    },
];


export default function () {
    const [
        { searchParam, checkList, checkListSelectedRowKeys, checkPage },
        { setCheckListSelectedRowKeys, setCheckDetailList, setCheck, loadCheckList, loadCheck, exportCheckList }
    ] = useModel("stockCheck");

    useEffect(() => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = checkPage
        const { inventoryListCode, orderStatus } = searchParam;
        let data = {
            startTime,
            endTime,
            inventoryListCode,
            orderStatus,
            pageSize,
            pageNum
        }
        loadCheckList({ showMsg: true, data })
    }, []);

    const history = useHistory();
    const onAdd = () => {
        setCheckDetailList([]);
        setCheck({});
        goPage(history, "4-2-2");
    }
    const onEdit = () => {
        loadCheck({ showMsg: false, data: checkListSelectedRowKeys[0] })
            .then(() => {
                goPage(history, "4-2-1");
            });

    }

    const onExport = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { inventoryListCode, orderStatus } = searchParam;
        let data = {
            startTime,
            endTime,
            inventoryListCode,
            orderStatus,
        }
        exportCheckList({ showMsg: true, data });
    }

    const TableHeader = () => {
        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_AD}>
                        <Button type="primary" onClick={onAdd}>新增</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED}>
                        <Button className="margin-left-8" onClick={onEdit}
                            disabled={checkListSelectedRowKeys.length === 0}>编辑</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_EX}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                </div>
                <div className="detail-list-statistic" style={{ textAlign: "right" }}>

                </div>
            </div>
        )
    }
    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={checkList}
                bordered
                pagination={{
                    hideOnSinglePage: false,
                    showSizeChanger: true,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: (pageNum, pageSize) => {
                        /*const params = {...searchParam};
                        params.pageNum = pageNum;
                        params.pageSize = pageSize;*/
                        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
                        const { inventoryListCode, orderStatus } = searchParam;
                        const data = { inventoryListCode, orderStatus, startTime, endTime, pageNum, pageSize }
                        loadCheckList({ showMsg: false, data });
                    },
                    total: checkPage.total,
                    current: checkPage.pageNum,
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (checkListSelectedRowKeys
                                && checkListSelectedRowKeys[0]
                                && checkListSelectedRowKeys[0] === record.key) {
                                setCheckListSelectedRowKeys([]);
                            } else {
                                setCheckListSelectedRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys) => {
                        setCheckListSelectedRowKeys(selectedRowKeys)
                    },
                    selectedRowKeys: checkListSelectedRowKeys
                }}
                scroll={{ x: 'max-content', y: 580 }}
            />
        </>
    );
}